import { Booking } from 'acscp/store';
import { Location, LocationDescriptor } from 'history';
import { LoginPageVariant } from 'acscp/store/loginPageVariant';

export const encodeLocationForRedirect = (location: Location<any>) =>
    encodeURIComponent(location.pathname + location.search + location.hash);

export const loginAndRedirectTo = (location: Location<any>, disallowGuest: boolean = false) =>
    `/login?redirect=${encodeLocationForRedirect(location)}${disallowGuest ? '&fullLoginRequired=true' : ''}`;
export const createAccountAndRedirectTo = (location: Location<any>) =>
    `/create-account?redirect=${encodeLocationForRedirect(location)}`;

export const home = () => '/';
export const chartersList = (subListDomId?: string): string => !!subListDomId ? `${chartersList()}#${subListDomId}` : `/trip`;

export const newFlightRequest = () => '/flight-requests/new';
export const editFlightRequest = (booking: Booking) => `/flight-requests/${booking.id}`;
export const repeatFlightRequest = (booking: Booking) => `/flight-requests/${booking.id}/repeat-request`;

export const defaultLoginUrlForVariant = (variant: LoginPageVariant): string => {
    if (variant === LoginPageVariant.LoyaltyScheme) {
        return '/login-my-rewards';
    }
    return '/login';
};
